export const normalizePermissionCatalog = (permissions) => {
  if (!Array.isArray(permissions)) return [];

  const seen = new Set();
  return permissions.filter((item) => {
    const permission = item?.Permission;
    if (typeof permission !== "string" || !permission.trim() || seen.has(permission)) {
      return false;
    }

    seen.add(permission);
    return true;
  });
};

export const normalizePermissionSetEntries = (entries) => {
  if (!Array.isArray(entries)) return [];

  const seen = new Set();
  return entries.reduce((normalized, entry) => {
    const permission = typeof entry?.Permission === "string"
      ? entry.Permission.trim()
      : "";
    const key = permission.toUpperCase();
    if (!permission || seen.has(key)) return normalized;

    seen.add(key);
    normalized.push(
      permission === entry.Permission
        ? entry
        : { ...entry, Permission: permission }
    );
    return normalized;
  }, []);
};

export const permissionSetNeedsEntryNormalization = (permissionSet) => {
  const entries = Array.isArray(permissionSet?.Entries) ? permissionSet.Entries : [];
  const normalizedEntries = normalizePermissionSetEntries(entries);
  return (
    normalizedEntries.length !== entries.length ||
    normalizedEntries.some((entry, index) => entry !== entries[index])
  );
};

export const normalizePermissionSet = (permissionSet) => {
  if (!permissionSet || typeof permissionSet !== "object" || Array.isArray(permissionSet)) {
    return permissionSet;
  }

  return {
    ...permissionSet,
    Entries: normalizePermissionSetEntries(permissionSet.Entries)
  };
};
